module.exports = __webpack_public_path__ + "img/signature-sample1_en.f216341a.png";